import { RouterManager } from '@router/RouterManager';

// A aplicação tem uma única tela; um menu lateral aqui seria só moldura.
export const App = () => <RouterManager />;
